import { render, staticRenderFns } from "./basedInspection.vue?vue&type=template&id=cf87ce8e&scoped=true&"
import script from "./basedInspection.vue?vue&type=script&lang=js&"
export * from "./basedInspection.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./basedInspection.vue?vue&type=style&index=1&id=cf87ce8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf87ce8e",
  null
  
)

export default component.exports